import styled from "styled-components"
import media from "styled-media-query"

const Card = styled.div`
  background-color: #fff;
  border: solid 1px #0445a3;
  border-radius: 100px;
  box-shadow: 0 0 1px #333;
  display: flex;
  font-size: 1em;
  font-weight: 700;
  height: 100%;
  letter-spacing: 1px;
  margin: 9px 0;
  width: 100%;
  ${media.greaterThan("small")`
    margin: 12px 0;
  `}
`

export default Card
